import { render, staticRenderFns } from "./AdditionalPages.vue?vue&type=template&id=7945aa4d&"
import script from "./AdditionalPages.vue?vue&type=script&lang=js&"
export * from "./AdditionalPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports